
import { Component, inject, input, OnInit, signal, ViewChild } from '@angular/core';
import { BackButtonComponent, ButtonComponent, CardComponent } from '@webapp/ui';
import { PaymentsListComponent } from '@webapp/payments/ui/components/payments-list/payments-list.component';
import { AddPaymentComponent } from '@webapp/payments/ui/components/add-payment/add-payment.component';
import { UsersService } from '@webapp/users/services/users.service';
import { firstValueFrom } from 'rxjs';
import { IUserDetail, IUserPaymentMethod } from '@webapp/users/interfaces/users.interface';
import { IPayment } from '@webapp/quoter//interfaces/payment.interface';

@Component({
  selector: 'app-user-payments',
  imports: [
    ButtonComponent,
    BackButtonComponent,
    PaymentsListComponent,
    AddPaymentComponent,
    CardComponent
],
  templateUrl: './user-payments.component.html',
  styleUrls: ['./user-payments.component.scss'],
})
export class UserPaymentsComponent implements OnInit {
  user = input.required<IUserDetail>();

  addPaymentMode = signal(false);
  paymentMethods = signal<IUserPaymentMethod[]>([]);
  paymentMethodsLoading = signal(true);
  paymentGateways = signal<string[]>(['meridional']);
  payment = signal<IPayment | null>(null);
  loading = signal(false);

  @ViewChild(AddPaymentComponent) addPaymentComponent!: AddPaymentComponent;

  usersService = inject(UsersService);

  ngOnInit() {
    this.getPaymentMethods();
  }

  async getPaymentMethods() {
    const userId = this.user().id;
    if (!userId) return;

    this.paymentMethodsLoading.set(true);
    try {
      const response = await firstValueFrom(this.usersService.getPaymentMethods(userId));
      this.paymentMethods.set(response);
    } catch (error) {
      console.error('Error loading payment methods:', error);
    } finally {
      this.paymentMethodsLoading.set(false);
    }
  }



  async setPayment(paymentData: IPayment) {
    const userId = this.user().id;
    if (!userId) return;

    this.loading.set(true);
    try {
      await firstValueFrom(this.usersService.addPaymentMethod(userId, paymentData));
      this.addPaymentMode.set(false);
      this.getPaymentMethods();
    } catch (error) {
      console.error('Error adding payment method:', error);
    } finally {
      this.loading.set(false);
    }
  }
}
